// Money: always currency symbol + thousands separators, no decimals.
export const fmtMoney = (cur, v, sign) => {
  if (v == null || isNaN(v)) return "—";
  const s = `${cur || ""}${Math.round(Math.abs(v)).toLocaleString("en-US")}`;
  if (sign === "minus") return `−${s}`;
  if (sign === "plus") return `+${s}`;
  return v < 0 ? `−${s}` : s;
};

export const fmtPct = (v, dp = 0) =>
  v == null || isNaN(v) ? "—" : `${Number(v).toFixed(dp)}%`;

export const fmtNum = (v) =>
  v == null || isNaN(v) ? "—" : Math.round(v).toLocaleString("en-US");

// Sharp Cut palette
export const COLORS = {
  ink: "#0d0d0d",
  paper: "#ffffff",
  panel: "#f2f3ef",
  green: "#007d62",
  greenBright: "#00c389",
  greenSoft: "#e2efe9",
  grey: "#565b57",
  greyD: "#96a09a",
  good: "#007d62",
  bad: "#d6453d",
  warn: "#e8a13c",
  // Aliases kept for backwards-compatible imports across the app:
  blue: "#0d0d0d",   // secondary series → ink
  red: "#d6453d",
  amber: "#e8a13c",
  coral: "#007d62",  // any legacy accent → green
  indigo: "#0d0d0d",
};

// Account score ring colours (Sharp Cut mapping — no blue, one green moment)
export const scoreColor = (s) =>
  s >= 80 ? COLORS.good : s >= 60 ? COLORS.ink : s >= 40 ? COLORS.warn : COLORS.bad;

// ACoS pill colour: <20% good, 20–35% warn, >35% bad
export const acosColor = (a) =>
  a == null ? COLORS.grey : a < 20 ? COLORS.good : a <= 35 ? COLORS.warn : COLORS.bad;
